if (!window.xprops) {
  window.xprops = {
    variantCode: 'P1SYRNPK03',
    isWidgetMode: false,
    environment: 'development',
  };
}

export default {};
